import SearchResults from './SearchResults';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from './SearchResults.state';

export default connect(mapStateToProps, mapDispatchToProps)(SearchResults);
